import type { HTMLAttributeAnchorTarget } from 'react';
import { requestWithAuth } from '~/lib/.client/request-with-auth';
import { CLIENT_ORIGIN } from '~/lib/constants';
import { createScopedLogger } from '~/utils/logger';

const logger = createScopedLogger('openWithStackblitzAuth');

async function getStackBlitzOneTimeTokenClient(method: string, path: string): Promise<string | undefined> {
  const api = requestWithAuth(CLIENT_ORIGIN, true);

  try {
    const result = await api<{ token: string }>('/api/tokens/one_time_tokens', { method, path }, 'POST');

    return result?.token;
  } catch {
    return undefined;
  }
}

export async function openWithStackblitzAuth(targetUrl: string, target?: HTMLAttributeAnchorTarget) {
  const linkTarget = target || '_blank';

  const token = await getStackBlitzOneTimeTokenClient('GET', '/users/auth/bolt');

  if (!token) {
    logger.error('Failed to get StackBlitz one-time token to ensure authentication');
    window.open(`${CLIENT_ORIGIN}${targetUrl}`, linkTarget);

    return;
  }

  const redirectTo = encodeURIComponent(targetUrl);
  window.open(
    `${CLIENT_ORIGIN}/users/auth/bolt?token=${encodeURIComponent(token)}&redirect_to=${redirectTo}`,
    linkTarget,
  );
}
